import {
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Modal,
  MenuItem,
  Paper,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography
} from '@material-ui/core';
import {
  Build,
  Edit,
  MenuBook,
  Palette,
  Public,
  Style
} from '@material-ui/icons';
import api from 'services/api';
import { diff } from 'deep-diff';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import i18n from 'translations/langEngine';
import { validateField } from 'lib/functions';
import ButtonA2X from 'views/Components/Bottombar';
import { withStyles } from '@material-ui/core/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { CommonTranslations } from 'translations/translationKeys';
import { loadCompany, loadConfigurations } from 'lib/configUtils';
import { ANAO, APAGINA_EDITADA, APAGINA_NOVA, ASIM } from 'consts';
import TraducaoSisarePassengerForm from './Traducao/TraducaoSisarePassengerForm.js';

function TabContainer(props) {
  return (
    <Typography
      component="div"
      style={{ padding: 8 * 3 }}
    >
      {props.children}
    </Typography>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  textField: {
    marginTop: theme.spacing(0),
    marginBottom: '0.5rem',
    marginRight: '0.5rem'
  },
  addButton: {
    height: 42,
    display: 'flex',
    alignItems: 'center',
    float: 'right'
  },
  textarea: {
    width: '100%',
    height: 100,
    padding: theme.spacing(1),
    boxSizing: 'border-box'
  },
  dialogContent: { padding: theme.spacing(2) }
});

class AdmSisarePassengerForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pagina: {},
      pagina_original: {},
      activetab: 0,
      isNewRecord: false,
      isView: false,
      openAlert: false,
      isLoadingCity: true,
      isLoadingCliente: false,
      translations: {}, // armazenará as traduções
      termos: [],
      errors: {},
      modelosVoucher: [],
      color: "#000000", // estado para armazenar a cor selecionada
      showPicker: false, // estado para controlar a visibilidade do seletor
      schema: {
        titular: {
          presence: {
            allowEmpty: false,
            message: 'Título da página obrigatório'
          },
          length: { maximum: 100 },
          type: 'string'
        }
      }
    };
  };

  async componentDidMount() {
    this.setState({ isLoadingCliente: true });
    this.performsTranslation();

    const { location, match } = this.props;
    const { id } = match.params;
    const currentPath = location.pathname;

    if (id > 0) {
      const response = await api.get(`/appcli/pages/${id}`);
      const paginaData = response.data[0];
      paginaData.exibedataservico = String(paginaData.exibedataservico ?? paginaData.EXIBEDATASERVICO ?? ANAO).trim().toUpperCase() === ASIM ? ASIM : ANAO;
      await this.loadModelosVoucher();
      const pagina_original = paginaData;

      this.setState({
        pagina: paginaData,
        pagina_original: pagina_original,
        activeTab: '1',
        isNewRecord: false,
        isView: (currentPath.includes('/view'))
      });

      this.setState({
        activeTab: '1',
        isNewRecord: false
      });
    } else {
      if (id === 'novo') {
        this.setState({
          activeTab: '1',
          isNewRecord: true
        });

        isNewRecord = true;
      }
    }
  };

  handleChangeTab = (event, value) => {
    this.setState({ activetab: value });

    if (value === 1) {
    } else if (value === 2) {
    } else if (value === 3) {
      this.loadTermos();
    } else if (value == 4) {
    }
  };

  /* Usado para não exibir um componente */
  getNotDisplay(show) {
    if (show) {
      return 'none';
    } else {
      return '';
    }
  }

  /* Insere a nova página */
  insereDados = async () => {
    const { pagina } = this.state;
    const { history } = this.props;

    pagina['codusuario'] = parseInt(sessionStorage.getItem('codUser'), 10);
    pagina['codempresa'] = parseInt(sessionStorage.getItem('codEmpresa'), 10);
    pagina['codpdv'] = parseInt(sessionStorage.getItem('codPDV'), 10);

    this.setState({ pagina: pagina });

    try {
      const response = await api.post(`/admappcli/page`, pagina);

      if (response.status === 200) {
        alert('Página inserida com sucesso');

        history.push('/admappcli/adm-sisare-passenger-list');
      }
    } catch (error) {
      this.handleOpenAlert(error.response.data.error);
    }
  };

  /* Atualiza os dados da OS */
  atualizaDados = async () => {
    const { pagina, pagina_original } = this.state;
    const { history } = this.props;

    // identificar as diferenças entre os objetos
    const differences = diff(pagina_original, pagina);

    if (!differences) {
      history.push('/admappcli/adm-sisare-passenger-list');

      return;
    }

    // filtrar as diferenças para criar um novo objeto com as alterações
    const paginaAlterada = {};

    differences.forEach(d => {
      if (d.kind === APAGINA_EDITADA || d.kind === APAGINA_NOVA) {
        paginaAlterada[d.path.join('.')] = d.rhs; // d.path é o caminho da propriedade
      }
    });

    // inclua os campos obrigatórios, se necessário
    // Persiste explicitamente a configuração, inclusive quando o retorno da API usa maiúsculas.
    paginaAlterada['exibedataservico'] = pagina.exibedataservico === ASIM ? ASIM : ANAO;
    paginaAlterada['codusuarioregistrou'] = parseInt(sessionStorage.getItem('codUser'), 10);
    paginaAlterada['codempresa'] = parseInt(sessionStorage.getItem('codEmpresa'), 10);

    try {
      const response = await api.put(`/admappcli/page/${pagina.id}`, paginaAlterada);

      if (response.status === 200) {
        history.push('/admappcli/adm-sisare-passenger-list');
      }
    } catch (error) {
      this.handleOpenAlert(error.response.data.message);
    }
  };

  loadModelosVoucher = async () => {
    try {
      const response = await api.get('/modelorelatorio/active/true?TBMODELORELATORIO.TIPOMODELO=23');
      this.setState({ modelosVoucher: response.data || [] });
    } catch (error) {
      console.error('Erro ao carregar modelos de Voucher Digital:', error);
      this.setState({ modelosVoucher: [] });
    }
  };

  /* Carrega os termos de tradução do módulo Sisare-passenger */
  async loadTermos() {
    const params = `tbtraducaoweb.chave=_like_sis-passenger`;
    const url = `/traducao/termos?${params}`;

    const termos = await api.get(url);

    this.setState({ termos: termos.data });
  };

  OnChange = (event) => {
    const { name, type, value, checked } = event.target;

    let adjustedValue = value;

    switch (type) {
      case 'checkbox':
        adjustedValue = (name === 'audio_guia') ? (checked ? ASIM : ANAO) : (checked ? ASIM : ANAO);
        break;
      case 'select-one':
        adjustedValue = (name === 'regimehosp') ? value : Number(value);
        break;
      default:
        adjustedValue = value;
        break;
    };

    this.setState(prevState => ({
      pagina: {
        ...prevState.pagina,
        [name]: adjustedValue
      },
      errors: {
        ...prevState.errors,
        [name]: typeof adjustedValue === 'string' && adjustedValue.trim() === ''
      }
    }));
  };

  /* Clicar para salvar */
  onClickSave = () => {
    const { isNewRecord } = this.state;

    if (isNewRecord) {
      this.insereDados();
    } else {
      this.atualizaDados();
    }
  };

  /* Clicar para cancelar */
  onClickCancel = () => {
    this.props.history.push('/admappcli/adm-sisare-passenger-list');
  };

  /* Fecha a janela com mensagem de alerta */
  handleCloseAlert = () => {
    const { onCloseCallback } = this.state;

    this.setState({ openAlert: false });

    if (onCloseCallback) {
      onCloseCallback();
    }
  };

  /* Abre a janela de mensagem com alerta */
  handleOpenAlert = (message, callback) => {
    this.setState({
      openAlert: true,
      messageAlert: message,
      onCloseCallback: callback || null
    });

    // mantém o comportamento visível e evita erro em validações / catches
    if (message) {
      alert(message);
    }
  };

  /* Envio de dados */
  handleSubmit = () => {
    let errors = {};
    errors = this.validationRequiredFields();

    this.setState({ errors });

    if (Object.keys(errors).length === 0) {
      this.onClickSave();
    }
  };

  /* Valida os campos obrigatórios */
  validationRequiredFields = () => {
    const { pagina, schema } = this.state;

    let errors = {};

    // valida a página
    const titulo_paginaError = validateField('titular', pagina.titulo_pagina, schema);

    if (titulo_paginaError) {
      errors.titulo_pagina = titulo_paginaError;
    }

    const exibeVoucher = pagina.exibevoucherdigital === ASIM || pagina.EXIBEVOUCHERDIGITAL === ASIM;
    const codModeloVoucher = Number(pagina.codmodelovoucher || pagina.CODMODELOVOUCHER || 0);
    if (exibeVoucher && codModeloVoucher <= 0) {
      errors.codmodelovoucher = 'Selecione o modelo do Voucher Digital.';
    }

    if (Object.keys(errors).length !== 0) {
      this.handleOpenAlert('Verifique os campos obrigatórios!');

      return errors;
    }

    return errors;
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  /* Fecha a janela de confirmação de exclusão de pax */
  openPaxDeleteModal = (idpax, nomepax) => {
    this.setState({ selectedIdPax: idpax });
    this.setState({ selectedNomePax: nomepax });
    this.setState({ isPaxDeleteModalOpen: true });
  };

  /* Fecha a janela de confirmação de exclusão de pax */
  closePaxDeleteModal = () => {
    this.setState({ isPaxDeleteModalOpen: false });
  };

  /* Abre o modal do formulário de pax */
  openTraducaoModal = (id = 'novo') => {
    const { isNewRecord, termos } = this.state;

    let traducaoEncontrado = {};

    if (isNewRecord) {
      if (id !== 'novo') {
        traducaoEncontrado = termos.find(
          traducao => traducao.chave === chaveProcurado
        );
      }
    }

    this.setState({
      open: true,
      selectedChaveTraducao: id, // define o ID do pax que será editado, ou 'novo' para criar
      selectedTraducao: traducaoEncontrado
    });
  };

  /* Realiza a tradução */
  async performsTranslation() {
    const termsNeeded = [
      CommonTranslations.BUTTON_SAVE,
      CommonTranslations.BUTTON_CANCEL,
      CommonTranslations.CHECKBOX_INATIVO,
      CommonTranslations.TABSHEET_GERAL
    ];

    // lista de termos da página
    const translations = await i18n.fetchTerms(termsNeeded);

    this.setState({ translations });
  };

  /* Atualiza a cor ao escolher no seletor */
  handleColorChange = (newColor) => {
    this.setState({ color: newColor.hex });
  };

  closePassengerScreen = () => {
    this.setState({ showPassengerScreen: false });
  };

  handleInputChange = (event) => {
    const value = event.target.value;

    // valida se é hexadecimal
    if (/^#[0-9A-F]{6}$/i.test(value)) {
      this.setState({ color: value });
    } else {
      this.setState({ color: "#000000" });
    }
  };

  /* Mostra o seletor de cores */
  showColorPicker = () => {
    this.setState({ showPicker: true });
  };

  /* Esconde o seletor de cores */
  hideColorPicker = () => {
    this.setState({ showPicker: false });
  };

  /* Método para atualizar a lista de pax */
  updateTraducaoList = async (traducao) => {
    const { isNewRecord, termos } = this.state;

    try {
      if (!isNewRecord) {
        const termos = await api.get(
          `/traducao/xxx/${traducao.chave}?sort=tbpaxgeral.seqpaxos`
        );

        if (termos.status === 200) {
          this.setState({ termos: termos.data });
        }
      } else {
        const index = termos.findIndex(termo => termo.chave === termooff.chave);

        if (index !== -1) {
          const novaListaTermos = [
            ...termos.slice(0, index),
            termooff,
            ...termos.slice(index + 1)
          ];

          this.setState({ termos: novaListaTermos });
        }
      }

      this.loadCityPax();
    } catch (error) {
      this.handleOpenAlert(error.response.data.error);
    }
  };

  render() {
    const {
      activetab,
      errors,
      isNewRecord,
      isView,
      open,
      pagina,
      selectedChaveTraducao,
      termos,
      translations
    } = this.state;

    const { classes } = this.props;

    return (
      <div>
        <AppBar
          color="default"
          position="static"
        >
          <Tabs
            indicatorColor="primary"
            onChange={this.handleChangeTab}
            textColor="primary"
            value={activetab}
          >
            <Tab
              icon={<Public />}
              label={translations[''] || 'Dados'}
            />

            <Tab
              icon={<Palette />}
              label="Imagens e Cores"
            />

            <Tab
              icon={<Build />}
              id="tab3"
              label="Recursos"
            />

            <Tab
              icon={<MenuBook />}
              id="tab4"
              label="Tradução"
            />

            <Tab
              icon={<Style />}
              id="tab5"
              label="Personalizações"
            />
          </Tabs>
        </AppBar>

        {/* ABA GERAL */}
        {activetab === 0 &&
          <TabContainer>
            <CardContent style={{ display: this.getNotDisplay(isNewRecord) }}>
              <Typography variant="h3">
                Configuração Sisare Passenger
              </Typography>

              <Typography
                color="textSecondary"
                component="p"
                variant="body2"
              ></Typography>
            </CardContent>

            <Box width="100%">
              <TextField
                className={classes.textField}
                style={{ marginRight: '1rem' }}
                label="Título da página"
                name="titulo_pagina"
                onChange={this.OnChange}
                type="text"
                value={pagina.titulo_pagina || ''}
                variant="outlined"
                disabled={isView}
              />

              <TextField
                className={classes.textField}
                style={{ width: '50%' }}
                label="URL da página"
                name="url_default"
                value={pagina.url_default || ''}
                onChange={this.OnChange}
                error={!!errors.url_default}
                helperText={errors.url_default || ''}
                variant="outlined"
                disabled={isView}
              />

              <TextField
                className={classes.textField}
                style={{ width: '50%' }}
                label="URL local"
                name="url_local"
                value={pagina.url_local || ''}
                onChange={this.OnChange}
                error={!!errors.url_local}
                helperText={errors.url_local || ''}
                variant="outlined"
                disabled={isView}
              />
            </Box>

            <TextField
              className={classes.textField}
              label="Endereço completo"
              name="endereco_completo"
              onChange={this.OnChange}
              type="text"
              value={pagina.endereco_completo || ''}
              variant="outlined"
              error={!!errors.email}
              helperText={errors.email || ''}
              disabled={isView}
              style={{
                width: '40%',
                marginRight: '1rem'
              }}
            />

            <TextField
              className={classes.textField}
              label="Fone Contato"
              name="fone_contato"
              onChange={this.OnChange}
              type="text"
              value={pagina.fone_contato || ''}
              variant="outlined"
              error={!!errors.email}
              helperText={errors.email || ''}
              disabled={isView}
              style={{
                width: '40%',
                marginRight: '1rem'
              }}
            />

            <TextField
              className={classes.textField}
              label="Fone SAC WhatsApp"
              name="fone_sac"
              onChange={this.OnChange}
              type="text"
              value={pagina.fone_sac || ''}
              variant="outlined"
              error={!!errors.fone_sac}
              helperText={errors.fone_sac || ''}
              disabled={isView}
              style={{
                width: '40%',
                marginRight: '1rem'
              }}
            />

            <TextField
              className={classes.textField}
              label="E-mail contato"
              name="email_contato"
              onChange={this.OnChange}
              type="text"
              value={pagina.email_contato || ''}
              variant="outlined"
              error={!!errors.email_contato}
              helperText={errors.email_contato || ''}
              disabled={isView}
              style={{
                width: '40%',
                marginRight: '1rem'
              }}
            />

            <TextField
              className={classes.textField}
              label="URL Instagram"
              name="url_instagram"
              onChange={this.OnChange}
              type="text"
              value={pagina.url_instagram || ''}
              variant="outlined"
              error={!!errors.url_instagram}
              helperText={errors.url_instagram || ''}
              disabled={isView}
              style={{
                width: '40%',
                marginRight: '1rem'
              }}
            />

            <TextField
              className={classes.textField}
              label="URL Facebook"
              name="url_facebook"
              onChange={this.OnChange}
              type="text"
              value={pagina.url_facebook || ''}
              variant="outlined"
              error={!!errors.url_facebook}
              helperText={errors.url_facebook || ''}
              disabled={isView}
              style={{
                width: '40%',
                marginRight: '1rem'
              }}
            />
          </TabContainer>
        }

        {/* ABA 1 */}
        {activetab === 1 &&
          <TabContainer>
            <div>
              <Box width="100%" >
                <FormControl
                  disabled={isView}
                  style={{
                    width: '40%',
                    maxWidth: '1'
                  }}
                >
                  <Box width="100%">
                    <TextField
                      className={classes.textField}
                      label="Cor primária"
                      name="cor_primaria"
                      onChange={this.OnChange}
                      type="text"
                      value={pagina.cor_primaria || ''}
                      variant="outlined"
                      disabled={isView}
                      style={{ marginRight: '1rem' }}
                    />

                    <TextField
                      className={classes.textField}
                      label="Cor secundária"
                      name="cor_secundaria"
                      onChange={this.OnChange}
                      type="text"
                      value={pagina.cor_secundaria || ''}
                      variant="outlined"
                      disabled={isView}
                      style={{ marginRight: '1rem' }}
                    />

                    <TextField
                      className={classes.textField}
                      label="URL Logo"
                      name="logo_url"
                      onChange={this.OnChange}
                      type="text"
                      value={pagina.logo_url || ''}
                      variant="outlined"
                      disabled={isView}
                      style={{
                        width: '80%',
                        marginRight: '1rem'
                      }}
                    />

                    <TextField
                      className={classes.textField}
                      label="Favicon"
                      name="favicon_url"
                      onChange={this.OnChange}
                      type="text"
                      value={pagina.favicon_url || ''}
                      variant="outlined"
                      error={!!errors.favicon_url}
                      helperText={errors.favicon_url || ''}
                      disabled={isView}
                      style={{
                        width: '80%',
                        marginRight: '1rem'
                      }}
                    />

                    <TextField
                      className={classes.textField}
                      label="URL Imagem Principal [1800 x 700]"
                      name="img_principal_url"
                      onChange={this.OnChange}
                      type="text"
                      value={pagina.img_principal_url || ''}
                      variant="outlined"
                      error={!!errors.img_principal_url}
                      helperText={errors.img_principal_url || ''}
                      disabled={isView}
                      style={{
                        width: '80%',
                        marginRight: '1rem'
                      }}
                    />

                    <Typography
                      color="textSecondary"
                      component="p"
                      variant="body2"
                    >
                      Texto imagem principal - Português
                    </Typography>

                    <textarea
                      id="texto_img_principal_ptbr"
                      name="texto_img_principal_ptbr"
                      onChange={this.OnChange}
                      className={classes.textarea}
                      value={pagina.texto_img_principal_ptbr || ''}
                      disabled={isView}
                    />

                    <Typography
                      color="textSecondary"
                      component="p"
                      variant="body2"
                    >
                      Sub-Texto imagem principal - Português
                    </Typography>

                    <textarea
                      id="subtexto_img_principal_ptbr"
                      name="subtexto_img_principal_ptbr"
                      onChange={this.OnChange}
                      className={classes.textarea}
                      value={pagina.subtexto_img_principal_ptbr || ''}
                      disabled={isView}
                    />

                    <Typography
                      color="textSecondary"
                      component="p"
                      variant="body2"
                    >
                      Texto imagem principal - Espanhol
                    </Typography>

                    <textarea
                      id="texto_img_principal_escl"
                      name="texto_img_principal_escl"
                      onChange={this.OnChange}
                      className={classes.textarea}
                      value={pagina.texto_img_principal_escl || ''}
                      disabled={isView}
                    />

                    <Typography
                      color="textSecondary"
                      component="p"
                      variant="body2"
                    >
                      Sub-Texto imagem principal - Espanhol
                    </Typography>

                    <textarea
                      id="subtexto_img_principal_escl"
                      name="subtexto_img_principal_escl"
                      onChange={this.OnChange}
                      className={classes.textarea}
                      value={pagina.subtexto_img_principal_escl || ''}
                      disabled={isView}
                    />

                    <Typography
                      color="textSecondary"
                      component="p"
                      variant="body2"
                    >
                      Texto imagem principal - Inglês
                    </Typography>

                    <textarea
                      id="texto_img_principal_enus"
                      name="texto_img_principal_enus"
                      onChange={this.OnChange}
                      className={classes.textarea}
                      value={pagina.texto_img_principal_enus || ''}
                      disabled={isView}
                    />

                    <Typography
                      color="textSecondary"
                      component="p"
                      variant="body2"
                    >
                      Sub-Texto imagem principal - Inglês
                    </Typography>

                    <textarea
                      id="subtexto_img_principal_enus"
                      name="subtexto_img_principal_enus"
                      onChange={this.OnChange}
                      className={classes.textarea}
                      value={pagina.subtexto_img_principal_enus || ''}
                      disabled={isView}
                    />

                    <TextField
                      className={classes.textField}
                      id="logo_programacao"
                      label="URL Logo Programação Passageiro "
                      name="logo_programacao"
                      onChange={this.OnChange}
                      type="text"
                      value={pagina.logo_programacao || ''}
                      variant="outlined"
                      error={!!errors.logo_programacao}
                      helperText={errors.logo_programacao || ''}
                      disabled={isView}
                      style={{
                        width: '80%',
                        marginRight: '1rem'
                      }}
                    />
                  </Box>
                </FormControl>

                <Paper
                  style={{
                    maxWidth: 160,
                    width: '100%',
                    float: 'right',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 0
                  }}
                ></Paper>
              </Box>
            </div>
          </TabContainer>
        }

        {/* ABA RECURSOS */}
        {activetab === 2 &&
          <TabContainer>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Guiamento de escalas com áudio
              </FormLabel>

              <FormControlLabel
                label={pagina.audio_guia === ASIM ? 'Sim' : 'Não'}
                control={
                  <Switch
                    checked={pagina.audio_guia === ASIM}
                    name="audio_guia"
                    onChange={this.OnChange}
                    color="primary"
                    disabled={isView}
                  />
                }
              />

              <Box width="100%">
                <br />

                <TextField
                  className={classes.textField}
                  label="URL e porta streaming comunicação"
                  name="url_port_streaming"
                  onChange={this.OnChange}
                  type="text"
                  value={pagina.url_port_streaming || ''}
                  variant="outlined"
                  disabled={isView}
                />
              </Box>
            </FormControl>
          </TabContainer>
        }

        {/* ABA TRADUÇÃO */}
        {activetab === 3 &&
          <TabContainer>
            <FormControl component="fieldset">
              <Card>
                <CardContent>
                  <PerfectScrollbar>
                    <div>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Chave</TableCell>

                            <TableCell>Português BR</TableCell>

                            <TableCell>Espanhol CL </TableCell>

                            <TableCell>Inglês US </TableCell>

                            <TableCell>
                              {translations[CommonTranslations.GRID_COLUMN_ACOES] || 'Ações'}
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {termos.slice(0, 1000).map(termo => (
                            <TableRow
                              hover
                              key={termo.chave}
                            >
                              <TableCell>{termo.chave}</TableCell>

                              <TableCell>{termo.termoportuguesbr}</TableCell>

                              <TableCell>{termo.termoespanholcl}</TableCell>

                              <TableCell>{termo.termoinglesus}</TableCell>

                              <TableCell>
                                <Button
                                  color="primary"
                                  onClick={() => this.openTraducaoModal(termo.chave)}
                                >
                                  <Edit />
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>

                      <Modal
                        open={open}
                        onClose={this.handleClose}
                      >
                        <div
                          style={{
                            margin: '100px auto',
                            width: '80%',
                            padding: 20,
                            backgroundColor: 'white'
                          }}
                        >
                          <TraducaoSisarePassengerForm
                            traducao={selectedChaveTraducao}
                            onClose={this.handleClose}
                            onSave={(updatePax) => {
                              this.handleClose();
                              this.loadTermos();
                            }}
                            isModal={true}
                            chave={selectedChaveTraducao}
                            id={selectedChaveTraducao}
                          />
                        </div>
                      </Modal>
                    </div>
                  </PerfectScrollbar>
                </CardContent>
              </Card>
            </FormControl>
          </TabContainer>
        }

        {/* ABA PERSONALIZAÇÃO */}
        {activetab === 4 &&
          <TabContainer>
            <Typography variant="h5">
              Personalizações <b>WhatsApp</b>
            </Typography>

            <Box width="100%">
              <TextField
                className={classes.textField}
                label="Mensagem personalizada WhatsApp"
                name="msgwhatsperso"
                onChange={this.OnChange}
                value={pagina.msgwhatsperso || ''}
                variant="outlined"
                multiline
                minRows={6}
                disabled={isView}
                helperText="Mensagem que será enviada automaticamente ao WhatsApp"
                style={{
                  width: '80%',
                  marginTop: '1rem'
                }}
              />
            </Box>

            <Typography variant="h5">
              Configuração de Link para <b>Avaliação</b>
            </Typography>

            <Box width="100%" />

            <Box
              display="flex"
              alignItems="center"
              style={{
                width: '80%',
                marginTop: '1rem',
                gap: '1rem'
              }}
            >
              <FormControlLabel
                label="Trabalha com link dinâmico de Avaliação"
                control={
                  <Checkbox
                    checked={
                      pagina.trabalhacomlinkavaliacao === ASIM ||
                      pagina.TRABALHACOMLINKAVALIACAO === ASIM
                    }
                    onChange={this.OnChange}
                    name="trabalhacomlinkavaliacao"
                    color="primary"
                    disabled={isView}
                  />
                }
              />

              <TextField
                className={classes.textField}
                label="Link dinâmico de Avaliação"
                name="linkpersoavaliacao"
                onChange={this.OnChange}
                value={pagina.linkpersoavaliacao || pagina.LINKPERSOAVALIACAO || ''}
                variant="outlined"
                style={{ flex: 1 }}
                disabled={isView || pagina.trabalhacomlinkavaliacao !== ASIM}
                error={!!errors.linkpersoavaliacao}
                helperText={
                  errors.linkpersoavaliacao ||
                  'Informe o link que será utilizado na avaliação'
                }
              />
            </Box>

            <Typography variant="h5" style={{ marginTop: '1.5rem' }}>
              Configuração do <b>Voucher Digital</b>
            </Typography>

            <Box
              display="flex"
              alignItems="center"
              style={{ width: '80%', marginTop: '1rem', gap: '1rem' }}
            >
              <FormControlLabel
                label="Exibir Voucher Digital para download no Passenger"
                control={
                  <Checkbox
                    checked={pagina.exibevoucherdigital === ASIM || pagina.EXIBEVOUCHERDIGITAL === ASIM}
                    onChange={this.OnChange}
                    name="exibevoucherdigital"
                    color="primary"
                    disabled={isView}
                  />
                }
              />

              <TextField
                select
                className={classes.textField}
                label="Modelo do Voucher Digital"
                name="codmodelovoucher"
                onChange={this.OnChange}
                value={pagina.codmodelovoucher || pagina.CODMODELOVOUCHER || 0}
                variant="outlined"
                style={{ flex: 1 }}
                disabled={isView || !((pagina.exibevoucherdigital === ASIM) || (pagina.EXIBEVOUCHERDIGITAL === ASIM))}
                error={!!errors.codmodelovoucher}
                helperText={errors.codmodelovoucher || 'Modelos de Extrato de OS (tipo 23)'}
              >
                <MenuItem value={0}><em>Selecione...</em></MenuItem>
                {this.state.modelosVoucher.map(modelo => (
                  <MenuItem key={modelo.codigo || modelo.CODIGO} value={modelo.codigo || modelo.CODIGO}>
                    {modelo.nome || modelo.NOME}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Typography variant="h5" style={{ marginTop: '1.5rem' }}>
              Configuração da <b>Data dos Serviços</b>
            </Typography>
            <FormControlLabel
              label="Exibir a data do serviço na programação do passageiro"
              control={
                <Checkbox
                  checked={pagina.exibedataservico === ASIM}
                  onChange={this.OnChange}
                  name="exibedataservico"
                  color="primary"
                  disabled={isView}
                />
              }
            />
            <Typography variant="caption" display="block">
              Desmarcado: data de apresentação (padrão). Marcado: data do serviço.
            </Typography>
          </TabContainer>
        }

        <div>
          <ButtonA2X
            onClick={() => { this.handleSubmit() }}
            disabled={isView}
          >
            Salvar
          </ButtonA2X>

          <ButtonA2X
            variant="contained"
            color="secondary"
            onClick={() => { this.onClickCancel() }}
          >
            Cancelar
          </ButtonA2X>
        </div>
      </div>
    );
  };
};

AdmSisarePassengerForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AdmSisarePassengerForm);